module.exports = __webpack_public_path__ + "static/media/copy.c9259f03.svg";